export const routes = {
	en: {
		home: "/",
		privacyPolicy: "",
		// privacyPolicy: "/privacy-policy",
		ccReport2020: "",
		// ccReport2020: "/customer-care-report-2020",
		customerCareLP: "/finance-customer-care",
		blogTag: "/blog/tag",
		blog: "/blog",
	},
	pl: {
		home: "/pl",
		privacyPolicy: "/pl/polityka-prywatnosci",
		ccReport2020: "/pl/raport2020",
		customerCareLP: "/pl/obsluga-klienta-finanse",
		blogTag: "/pl/blog/tag",
		blog: "/pl/blog",
	},
};
